<head>
  <link
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
    rel="stylesheet"
  />
  <link
    href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css"
    rel="stylesheet"
  />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
</head>

<div class="fixed-submenus">
  <!--contenedor fijo 1 ini-->
  <div class="web">
    <div class="topLogoContainer">
      <div class="topLogoCenter">
        <div class="container-fluid" style="padding: 0">
          <div class="row" style="margin: 0">
            <!-- Redes sociales -->
            <div class="col-sm-4 flex-left-icon">
              <a
                href="https://www.facebook.com/diariooficialelperuano"
                target="_blank"
              >
                <i
                  class="bi bi-facebook fs-5 social-icon-round"
                  alt="Facebook"
                ></i>
                <!-- <img src="assets/image/header/facebook.svg"  alt="Facebook" class="social-icon social-icon-round" /> -->
              </a>
              <a
                href="https://www.instagram.com/diarioelperuano/"
                target="_blank"
              >
                <i
                  class="bi bi-instagram fs-5 social-icon-round"
                  alt="Instagram"
                ></i>
                <!-- <img src="assets/image/header/h-v-f.png" alt="Instagram" class="social-icon" /> -->
              </a>
              <a
                href="https://www.linkedin.com/company/elperuano/"
                target="_blank"
              >
                <i
                  class="bi bi-linkedin fs-5 social-icon-round"
                  alt="Linkedin"
                ></i>
              </a>

              <a
                href="https://open.spotify.com/show/3XRNfOBL0cwFr7DpGuVtcl"
                target="_blank"
              >
                <i
                  class="bi bi-spotify fs-5 social-icon-round"
                  alt="Spotify"
                ></i>
              </a>

              <a href="https://www.tiktok.com/@diarioelperuano" target="_blank">
                <i class="bi bi-tiktok fs-5 social-icon-round" alt="TikTok"></i>
              </a>

              <a
                href="https://whatsapp.com/channel/0029Va5DnSb05MUmn4Mx0S0e"
                target="_blank"
              >
                <i
                  class="bi bi-whatsapp fs-5 social-icon-round"
                  alt="Whatsapp"
                ></i>
              </a>

              <a href="https://x.com/DiarioElPeruano" target="_blank">
                <i class="bi bi-twitter-x fs-5 social-icon-round" alt="X"></i>
              </a>

              <a
                href="https://www.youtube.com/@elperuanooficial"
                target="_blank"
              >
                <i
                  class="bi bi-youtube fs-5 social-icon-round"
                  alt="YouTube"
                ></i>
              </a>
            </div>
            <!-- Imagen centrada -->
            <div class="col-sm-4 flex-center-img-editora">
              <a (click)="goIndex($event)" role="button">
                <img
                  src="/assets/image/elperuano_logo_201.png"
                  alt="logo"
                  class="imagen-h-elperuano"
                />
              </a>
            </div>

            <!-- Carrito -->
            <!-- Carrito -->
            <div class="col-sm-4 flex-right-carrito">
              <div class="nav-item dropdown" ngDropdown #carritoDropdown="ngDropdown" [class.disabled]="rateLimitActive">
                <a
                  type="button"
                  ngDropdownControl
                  class="nav-link waves-light"
                  mdbWavesEffect
                  [style.cursor]="rateLimitActive ? 'not-allowed' : 'pointer'"
                  [style.opacity]="rateLimitActive ? '0.5' : '1'"
                  [style.pointer-events]="rateLimitActive ? 'none' : 'auto'"
                  style="
                    display: flex;
                    align-items: center;
                    margin-right: -20px;
                    padding: 20px 20px 20px 20px;
                  "
                  [attr.title]="rateLimitActive ? 'Carrito temporalmente deshabilitado debido a límite de solicitudes' : 'Ver carrito de compras'"
                >
                  <span style="margin-right: 8px">Carrito</span>

                  <!-- Contenedor del carrito con icono y contador -->
                  <div class="carrito-container" style="position: relative">
                    <img
                      class="carrito-container-img"
                      src="/assets/image/header/ico-carrito.png"
                      alt="Carrito de Compras"
                    />

                    <!-- Contador de productos -->
                    <div class="carrito-numero-compras" id="numeroCompras">
                      {{ cantidadCarrito }}
                    </div>
                  </div>
                </a>

                <!-- Contenido del dropdown -->
                <div
                  ngDropdownContent
                  class="dropdown-menu dropdown-primary"
                  dropdownClass="slide-fade"
                >
                  <app-carrito-compras-header
                    [flagActualizar]="flagActualizar"
                    (cerrarDropdown)="cerrarDropdownCarrito()"
                  ></app-carrito-compras-header>
                </div>
              </div>

              <span class="raya_vertical" style="margin-left: 25px"></span>

              <!-- Login -->
              <div class="nav-item dropdown" ngDropdown #loginDropdown="ngDropdown">
                <a
                  id="modallogin1"
                  mdbWavesEffect
                  type="button"
                  ngDropdownControl
                  class="nav-link waves-light"
                  style="padding-left: 0.5rem; padding-right: 0.5rem; display: flex; align-items: center; gap: 8px;"
                >
                  <span *ngIf="!obtenerSesion()" style="padding-right: 0.5rem">
                    Ingrese</span
                  >
                  <span *ngIf="obtenerSesion()"> Mi cuenta</span>
                  <span class="caret"></span>

                  <!-- Círculo con inicial cuando está logueado -->
                  <!-- Usuario logueado con inicial y bandera superpuesta -->
                  <div *ngIf="obtenerSesion()" class="user-icon-container">
                    <div class="user-avatar-circle">
                      {{ obtenerInicialUsuario() }}
                    </div>
                    <!-- Bandera superpuesta según geolocalización -->
                    <img
                      *ngIf="geoLocationLoaded"
                      [src]="getCurrentFlagUrl()"
                      [alt]="'Bandera de ' + getCurrentCountryName()"
                      class="country-flag-overlay"
                      [title]="'Visitando desde: ' + getCurrentCountryName()"
                      (error)="onFlagError($event)"
                    />
                  </div>

                  <!-- Icono por defecto cuando no está logueado con bandera superpuesta -->
                  <div *ngIf="!obtenerSesion()" class="user-icon-container">
                    <img
                      src="/assets/image/header/ico-user.png"
                      alt="icono-user"
                      class="ico-user"
                    />
                    <!-- Bandera superpuesta según geolocalización -->
                    <img
                      *ngIf="geoLocationLoaded"
                      [src]="flagUrl"
                      [alt]="'Bandera de ' + countryName"
                      class="country-flag-overlay"
                      [title]="'Visitando desde: ' + countryName"
                      (error)="onFlagError($event)"
                    />
                  </div>
                </a>
                <div
                  id="modallogin"
                  #modallogin
                  ngDropdownContent
                  class="dropdown-menu dropdown-primary"
                >
                  <app-login
                    (newItemEvent)="closeItem()"
                    (cerrarDropdown)="cerrarDropdownLogin()"
                  ></app-login>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--contenedor fijo 1 fin-->
  <!--contenedor fijo 2 ini-->
  <div class="web">
    <div class="topMenuBusquedaContainer">
      <div class="topMenuBusquedaCenter">
        <div class="container-fluid" style="padding: 0; margin: 0">
          <div class="row" style="display: flex; margin: 0; width: 100%">
            <!--justify-content: space-between; align-items:flex-start-->
            <div
              class="col-12 d-flex font-header-search"
              style="
                display: flex;
                justify-content: space-between;
                margin: 0;
                padding: 0;
                width: 100%;
                padding-top: 15px;
                padding-bottom: 10px;
                margin-left: 10px;
                margin-right: 10px;
              "
            >
              <div class="topMenuWrapper">
                <div
                  class="topMenuItem"
                  [ngClass]="{
                    'selected-category': selectedIdCategoria === '1'
                  }"
                  (click)="
                    selectOption('1');
                    visibilidad('#subMenuFotografia');
                    buscarConsulta('1', '')
                  "
                >
                  Fotografías
                </div>
                <div
                  class="topMenuItem"
                  [ngClass]="{
                    'selected-category': selectedIdCategoria === '2'
                  }"
                  (click)="
                    selectOption('2');
                    visibilidad('#subMenuPortada');
                    buscarConsulta('2', '')
                  "
                >
                  Páginas Históricas
                </div>
                <!--div class="topMenuItem" [ngClass]="{'selected-category': selectedIdCategoria === '3'}"
                      >Hemeroteca</div-->
              </div>

              <!--table class="topMenuTable">
                  <tr class="topMenuTR">
                    <td [ngClass]="{'selected-category': selectedIdCategoria === '1'}"
                        (click)="selectOption('1'); visibilidad('#subMenuFotografia'); buscarConsulta('1','')">Fotografías</td>
                    <td [ngClass]="{'selected-category': selectedIdCategoria === '2'}" 
                        (click)="selectOption('2'); visibilidad('#subMenuPortada'); buscarConsulta('2','')">Portadas Históricas</td>
                    <td [ngClass]="{'selected-category': selectedIdCategoria === '3'}"
                        (click)="selectOption('3'); visibilidad('#subMenuHemeroteca'); buscarConsulta('3','')">Hemeroteca</td>
                  </tr>
                </table-->
              <div style="padding-right: 10px; margin: 0">
                <div
                  class="input-group"
                  style="
                    margin: 0;
                    padding: 0;
                    display: flex;
                    align-items: center;
                  "
                >
                  <div
                    class="input-group-prepend"
                    style="
                      margin: 0;
                      padding: 0;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <span
                      class="input-group-text"
                      style="
                        margin: 0;
                        padding: 0;
                        padding-left: 1px;
                        padding-right: 1px;
                        justify-content: center;
                        align-items: center;
                      "
                    >
                      <i class="fas fa-search icono-lupa"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    id="idBusqueda"
                    [(ngModel)]="txtBusqueda"
                    (keyup.enter)="onBuscar('buscar')"
                    class="form-control busqueda-input"
                    placeholder="Búsqueda general, categoría, título, autor"
                  />
                </div>
              </div>
              <div style="padding: 0; margin: 0; display: flex">
                <ng-container *ngIf="!isFechaEnable">
                  <label for="txtFechaIni" class="fecha-label"
                    >Fecha Inicio</label
                  >
                  <input
                    type="date"
                    id="txtFechaIni"
                    [class.valid]="txtFechaIni === ''"
                    [class.invalid]="txtFechaIni !== ''"
                    [value]="fechaIniLoad"
                    [min]="minDate"
                    [max]="maxDateString"
                    maxlength="10"
                    [(ngModel)]="txtFechaIni"
                    (blur)="validateManualDateInput('inicio')"
                    (keyup.enter)="onBuscar('buscar')"
                    class="form-control fecha-input"
                    placeholder="dd/mm/yyyy"
                    mdbInput
                  />
                  <label for="txtFechaFin" class="fecha-label">Fecha Fin</label>
                  <input
                    type="date"
                    id="txtFechaFin"
                    [class.valid]="txtFechaIni === ''"
                    [class.invalid]="txtFechaIni !== ''"
                    [min]="minDate"
                    [max]="maxDateString"
                    [(ngModel)]="txtFechaFin"
                    maxlength="10"
                    (blur)="validateManualDateInput('fin')"
                    (keyup.enter)="onBuscar('buscar')"
                    class="form-control fecha-input"
                    placeholder="dd/mm/yyyy"
                    mdbInput
                  />
                </ng-container>
              </div>
              <button
                mdbBtn
                type="button"
                id="btnBuscar"
                (click)="onBuscar('buscar')"
                class="btn-personalizado"
                style="margin-right: 20px"
                mdbWavesEffect
              >
                Buscar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--contenedor fijo 2 fin-->
  <!--contenedor fijo 3 ini-->

  <div class="web">
    <div class="topSubMenuContainer">
      <div class="topSubMenuCenter">
        <div
          class="container-fluid"
          id="subMenuFotografia"
          *ngIf="selectedIdCategoria === '1' || selectedIdCategoria === ''"
          visible="true"
          style="padding: 0"
        >
          <div class="row" style="margin: 0">
            <div class="col-sm-12" style="padding: 0">
              <table class="w-100">
                <tr class="d-flex justify-content-center menuSubHeader">
                  <td (click)="buscarConsulta('1', '1')"
                    [ngClass]="{
                      'selected-subcategory': selectedIdSubCategoria === '1'
                    }"
                  >
                    <a >Cultura</a>
                  </td>
                  <td (click)="buscarConsulta('1', '2')"
                    [ngClass]="{
                      'selected-subcategory': selectedIdSubCategoria === '2'
                    }"
                  >
                    <a >Política</a>
                  </td>
                  <td (click)="buscarConsulta('1', '3')"
                    [ngClass]="{
                      'selected-subcategory': selectedIdSubCategoria === '3'
                    }"
                  >
                    <a >Deportes</a>
                  </td>
                  <td (click)="buscarConsulta('1', '4')"
                    [ngClass]="{
                      'selected-subcategory': selectedIdSubCategoria === '4'
                    }"
                  >
                    <a >Espectáculos</a>
                  </td>
                  <td (click)="buscarConsulta('1', '11')"
                    [ngClass]="{
                      'selected-subcategory': selectedIdSubCategoria === '11'
                    }"
                  >
                    <a >Regiones</a>
                  </td>
                  <td (click)="buscarConsulta('1', '12')"
                    [ngClass]="{
                      'selected-subcategory': selectedIdSubCategoria === '12'
                    }"
                  >
                    <a >Economía</a>
                  </td>
                  <td (click)="buscarConsulta('1', '13')"
                    [ngClass]="{
                      'selected-subcategory': selectedIdSubCategoria === '13'
                    }"
                  >
                    <a >Sociedad</a>
                  </td>
                  <td (click)="buscarConsulta('1', '14')"
                    [ngClass]="{
                      'selected-subcategory': selectedIdSubCategoria === '14'
                    }"
                  >
                    <a >Presidentes</a>
                  </td>
                </tr>
              </table>
            </div>
          </div>

        </div>
        <!--div class="container-fluid" id="subMenuPortada" style="display: none;" visible="false" style="padding: 0;"-->
        <div
          class="container-fluid"
          id="subMenuPortada"
          *ngIf="selectedIdCategoria === '2'"
          visible="true"
          style="padding: 0"
        >
          <div class="row" style="margin: 0">
            <div class="col-sm-12" style="padding: 0">
              <table class="w-100">
                <tr class="d-flex justify-content-center menuSubHeader">
                  <td (click)="buscarConsulta('2', '5')"
                    [ngClass]="{
                      'selected-subcategory': selectedIdSubCategoria === '5'
                    }"
                  >
                    <a >Portadas Siglo XIX</a>
                  </td>
                  <td (click)="buscarConsulta('2', '6')"
                    [ngClass]="{
                      'selected-subcategory': selectedIdSubCategoria === '6'
                    }"
                  >
                    <a >Portadas Siglo XX</a>
                  </td>
                  <td (click)="buscarConsulta('2', '7')"
                    [ngClass]="{
                      'selected-subcategory': selectedIdSubCategoria === '7'
                    }"
                  >
                    <a >Portadas Siglo XXI</a>
                  </td>
                  <!-- <td [ngClass]="{'selected-subcategory': selectedIdSubCategoria === '8'}"><a
                      (click)="buscarConsulta('2','8')">Centrales históricas</a></td> -->
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div
          class="container-fluid"
          id="subMenuHemeroteca"
          *ngIf="selectedIdCategoria === '3'"
          style="padding: 0"
        >
          <div class="row" style="margin: 0">
            <div class="col-sm-12" style="padding: 0">
              <table class="w-100">
                <tr class="d-flex justify-content-center menuSubHeader">
                  <td><a>Información desde 1825 a 1951</a></td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--contenedor fijo 3 fin-->

  <!--contenedor fijo 1 ini-->
  <div class="movil">
    <div class="topLogoContainerM">
      <div class="topLogoCenterM">
        <div class="container-fluid" style="padding: 0">
          <div class="row" style="margin: 0">
            <div class="col-7 flex-left-icon-m">
              <a [routerLink]="['/']">
                <img
                  src="/assets/image/elperuano_logo_201.png"
                  alt="logo"
                  class="imagen-h-elperuano"
                />
              </a>
            </div>
            <div class="col-5 flex-right-carrito">
              <div class="carrito-containerm" style="margin-right: 20px">
                <div class="nav-item dropdown" ngDropdown #carritoDropdownM="ngDropdown" [class.disabled]="rateLimitActive">
                  <a
                    type="button"
                    ngDropdownControl
                    class="nav-link waves-light"
                    mdbWavesEffect
                    [style.cursor]="rateLimitActive ? 'not-allowed' : 'pointer'"
                    [style.opacity]="rateLimitActive ? '0.5' : '1'"
                    [style.pointer-events]="rateLimitActive ? 'none' : 'auto'"
                    style="
                      padding-left: 0.5rem;
                      padding-right: 0rem;
                      padding-top: 0;
                    "
                    [attr.title]="rateLimitActive ? 'Carrito temporalmente deshabilitado' : 'Ver carrito'"
                  >
                    <img
                      class="carrito-container-imgm"
                      src="/assets/image/header/ico-carrito.png"
                      alt="Carrito de Compras"
                    />
                  </a>
                  <div
                    ngDropdownContent
                    class="dropdown-menu dropdown-primary"
                    dropdownClass="slide-fade"
                  >
                    <app-carrito-compras-header
                      [flagActualizar]="flagActualizar"
                      (cerrarDropdown)="cerrarDropdownCarritoM()"
                    ></app-carrito-compras-header>
                  </div>
                </div>
                <div class="carrito-numero-compras-m" id="numeroCompras">
                  {{ cantidadCarrito }}
                </div>
              </div>
              <div class="nav-item dropdown" ngDropdown #loginDropdownM="ngDropdown">
                <a
                  id="modallogin1"
                  mdbWavesEffect
                  type="button"
                  ngDropdownControl
                  class="nav-link waves-light"
                  style="padding-left: 0.25rem; padding-right: 1rem; display: flex; align-items: center;"
                >
                  <span
                    *ngIf="!obtenerSesion()"
                    style="padding-right: 0.5rem"
                  ></span>
                  <span *ngIf="obtenerSesion()"> </span>
                  <span class="caret"></span>

                  <!-- Usuario logueado con inicial y bandera superpuesta (mobile) -->
                  <div *ngIf="obtenerSesion()" class="user-icon-container-m">
                    <div class="user-avatar-circle-m">
                      {{ obtenerInicialUsuario() }}
                    </div>
                    <!-- Bandera superpuesta según geolocalización (mobile) -->
                    <img
                      *ngIf="geoLocationLoaded"
                      [src]="getCurrentFlagUrl()"
                      [alt]="'Bandera de ' + getCurrentCountryName()"
                      class="country-flag-overlay-m"
                      [title]="'Visitando desde: ' + getCurrentCountryName()"
                      (error)="onFlagError($event)"
                    />
                  </div>

                  <!-- Icono por defecto cuando no está logueado con bandera superpuesta (mobile) -->
                  <div *ngIf="!obtenerSesion()" class="user-icon-container-m">
                    <img
                      src="/assets/image/header/ico-user.png"
                      alt="icono-user"
                      class="ico-user-m"
                    />
                    <!-- Bandera superpuesta según geolocalización (mobile) -->
                    <img
                      *ngIf="geoLocationLoaded"
                      [src]="flagUrl"
                      [alt]="'Bandera de ' + countryName"
                      class="country-flag-overlay-m"
                      [title]="'Visitando desde: ' + countryName"
                      (error)="onFlagError($event)"
                    />
                  </div>
                </a>
                <div
                  id="modallogin"
                  #modallogin
                  ngDropdownContent
                  class="dropdown-menu dropdown-primary"
                >
                  <app-login
                    (newItemEvent)="closeItem()"
                    (cerrarDropdown)="cerrarDropdownLoginM()"
                  ></app-login>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--contenedor fijo 2 ini-->
  <div class="movil">
    <div class="topMenuBusquedaContainerM">
      <div class="topMenuBusquedaCenterM">
        <div class="container-fluid" style="padding: 0">
          <div class="row" style="margin: 0">
            <div
              class="flex-col-1p5 m-0 p-1"
              style="justify-content: center; align-items: center"
            >
              <!-- Menú Hamburguesa -->
              <nav class="navbar navbar-expand-lg navbar-light m-0 p-0">
                <button
                  class="navbar-toggler"
                  type="button"
                  (click)="toggleMenu()"
                  aria-label="Toggle navigation"
                  style="justify-content: center"
                >
                  <span class="navbar-toggler-icon hamburguesa-icono"></span>
                </button>
                <div
                  [ngbCollapse]="isMenuCollapsed"
                  class="navbar-collapse"
                  style="z-index: 1000"
                >
                  <ul class="navbar-nav mr-auto">
                    <li class="nav-item">
                      <a class="nav-link" href="#">Inicio</a>
                    </li>
                    <li
                      class="nav-item has-submenu"
                      [ngClass]="{ active: isCulturalMenuOpen }"
                    >
                      <a class="nav-link" (click)="toggleCulturalMenu()"
                        >Fotografías</a
                      >
                      <ul *ngIf="isCulturalMenuOpen" class="navbar-nav">
                        <li class="nav-item">
                          <a class="nav-link" (click)="buscarConsulta('1', '1')"
                            >Cultura</a
                          >
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" (click)="buscarConsulta('1', '2')"
                            >Política</a
                          >
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" (click)="buscarConsulta('1', '3')"
                            >Deportes</a
                          >
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" (click)="buscarConsulta('1', '4')"
                            >Espectáculos</a
                          >
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" (click)="buscarConsulta('1', '11')"
                            >Regiones</a
                          >
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" (click)="buscarConsulta('1', '12')"
                            >Economía</a
                          >
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" (click)="buscarConsulta('1', '13')"
                            >Sociedad</a
                          >
                        </li>
                        <li class="nav-item">
                          <a
                            class="nav-link"
                            (click)="buscarConsulta('1', '14')"
                            >Presidentes</a
                          >
                        </li>
                      </ul>
                    </li>
                    <li
                      class="nav-item has-submenu"
                      [ngClass]="{ active: isPortadasMenuOpen }"
                    >
                      <a class="nav-link" (click)="togglePortadaMenu()"
                        >Portadas</a
                      >
                      <ul *ngIf="isPortadasMenuOpen" class="navbar-nav">
                        <li class="nav-item">
                          <a class="nav-link" (click)="buscarConsulta('2', '5')"
                            >Siglo XIX</a
                          >
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" (click)="buscarConsulta('2', '6')"
                            >Siglo XX</a
                          >
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" (click)="buscarConsulta('2', '7')"
                            >Siglo XXI</a
                          >
                        </li>
                        <!-- <li class="nav-item">
                          <a class="nav-link" (click)="buscarConsulta('2','8')">Centrales Históricas</a>
                        </li> -->
                      </ul>
                    </li>
                    <!--li class="nav-item">
                    <a class="nav-link">Hemeroteca</a>
                  </li-->
                  </ul>
                </div>
              </nav>
            </div>
            <div
              class="col-9 m-0 p-1"
              style="display: flex; align-items: center"
            >
              <div
                class="input-group txt-altura-busqueda p-0 m-0"
                style="width: 100%; display: flex; align-items: center"
              >
                <div
                  class="input-group-prepend"
                  style="display: flex; align-items: center"
                >
                  <span
                    class="input-group-text txt-altura-busqueda"
                    style="display: flex; align-items: center"
                  >
                    <i class="fas fa-search" style="font-size: 14px"></i>
                  </span>
                </div>
                <input
                  type="text"
                  id="idBusquedaTxt"
                  [(ngModel)]="txtBusqueda"
                  (keyup.enter)="onBuscar('buscar')"
                  class="form-control txt-altura-busqueda"
                  placeholder="Búsqueda general, categoría, título, autor"
                  style="width: 80%"
                />
              </div>
            </div>
            <div class="flex-col-1p5 m-0 p-1" style="justify-content: center">
              <!--mat-form-field class="datePickerForm">
              <mat-date-range-input [formGroup]="range" [rangePicker]="picker" #dateRangeInput>
                  <input matStartDate formControlName="start" placeholder="Select date range" (dateChange)="onDateFilter('start',$event)" #startDate>
                  <input matEndDate formControlName="end" placeholder="" (dateChange)="onDateFilter('end',$event)" #endDate>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field-->

              <!-- Botón para abrir el modal de selección de fechas -->
              <button
                class="date-range-button"
                (click)="openDateRangeModal()"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  padding: 8px;
                  background: transparent;
                  border: none;
                  cursor: pointer;
                "
              >
                <img
                  src="/assets/image/header/ico-fecha-movil.png"
                  class="txt-altura-busqueda"
                  alt="Seleccionar Rango de Fechas"
                  style="padding-top: 0px; text-decoration: none"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--div class="movil">
  <div class="topMenuBusquedaContainerM">
    <div class="topMenuBusquedaCenterM">
      <div class="container-fluid" style="width:100%;padding: 0;">
        <div class="row d-flex align-items-center" style="margin: 0; width: 100%;"> 
          <nav class="navbar navbar-expand-lg navbar-light" style="padding: 0.10rem;margin-right: 10px;">
            <button class="navbar-toggler" type="button" (click)="toggleMenu()" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div [ngbCollapse]="isMenuCollapsed" class="navbar-collapse" style="z-index: 1000;">  
              <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                  <a class="nav-link" href="#">Inicio</a>
                </li>
                <li class="nav-item has-submenu" [ngClass]="{ 'active': isCulturalMenuOpen }">
                  <a class="nav-link" (click)="toggleCulturalMenu()">Fotografías</a>
                  <ul *ngIf="isCulturalMenuOpen" class="navbar-nav">
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('1','1')">Cultura</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('1','2')">Política</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('1','3')">Deportes</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('1','4')">Espectáculos</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('1','11')">Regiones</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('1','12')">Economía</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('1','13')">Sociedad</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('1','14')">Presidentes</a>
                    </li>
                  </ul>
                </li>        
                <li class="nav-item has-submenu" [ngClass]="{ 'active': isPortadasMenuOpen }">
                  <a class="nav-link" (click)="togglePortadaMenu()">Portadas</a>
                  <ul *ngIf="isPortadasMenuOpen" class="navbar-nav">
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('2','5')">Siglo XVIII</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('2','5')">Siglo XIX</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('2','6')">Siglo XX</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="buscarConsulta('2','7')">Siglo XXI</a>
                    </li>
                  </ul>
                </li>
                <li class="nav-item">
                  <a class="nav-link" (click)="buscarConsulta('3','')">Hemeroteca</a>
                </li>
              </ul>
            </div>
          </nav>
          <div>
            <div class="input-group" style="height: 22px; width: 100%; display: flex; align-items: center; margin-right: 10px;">
              <div class="input-group-prepend" style="display: flex; align-items: center;">
                <span class="input-group-text" style="height: 22px; display: flex; align-items: center;padding-left: 5px; padding-right: 5px;padding-top: 2px;padding-bottom: 2px;">
                  <i class="fas fa-search" style="font-size: 1rem;"></i>
                </span>
              </div>
              <input type="text" id="defaultLoginFormEmail" [(ngModel)]="txtBusqueda" (keyup.enter)="buscar()" 
                     class="form-control" placeholder="Búsqueda general, categoría, título, autor" 
                     style="height: 22px; font-size: 1rem; width: 100%; max-width: 210px;">
            </div>
          </div>
          <div style="display: flex;justify-content: center;align-items: center; ">
            <mat-form-field style="display: flex;justify-content: center;align-items: center; padding: 0;">
              <mat-label></mat-label>
              <mat-date-range-input [rangePicker]="picker" style="visibility: hidden;display: none;padding:0;"  (dateChange)="onDateChange($event)" >
                <input matStartDate [(ngModel)]="selectedDateRange.begin"  placeholder="Start date" (dateChange)="dateChanged('start', $event)" [min]="minDate" [max]="maxDate" [matDatepickerFilter]="dateFilter" >
                <input matEndDate [(ngModel)]="selectedDateRange.end" placeholder="End date" (dateChange)="dateChanged('end', $event)" [min]="minDate" [max]="maxDate" [matDatepickerFilter]="dateFilter" >
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker" style="display: flex;justify-content: center;align-items: center; padding: 0;">
                <mat-icon matDatepickerToggleIcon style="display: flex;justify-content: center;align-items: center;">
                  <img src="/assets/image/calendario.jpg" alt="Calendar Icon" style="width: 20px; height: 20px; padding-top: 0px;text-decoration: none;">
                </mat-icon>
              </mat-datepicker-toggle>
              <mat-date-range-picker #picker [startAt]="startDate">
              </mat-date-range-picker>
              <button mat-icon-button (click)="clearDates()">
                clear
              </button>
            </mat-form-field>
          </div>
        </div>
     </div>
    </div>
  </div>
</div-->
  <!--contenedor fijo 2 fin-->
  <!--contenedor fijo 3 ini-->
  <div class="movil">
    <div class="topSubMenuContainerM">
      <div class="topSubMenuCenterM">
        <div
          class="container-fluid"
          id="subMenuFotografia"
          visible="false"
          style="width: 100%; padding: 0; color: #fff !important"
        >
          <div class="row" style="margin: 0; width: 100%">
            <div class="col-sm-12" style="padding: 0; margin: 0">
              <table class="w-100" style="padding: 0px; margin: 0px">
                <tr
                  style="padding: 0px; margin: 0px"
                  class="d-flex justify-content-center custom-bg-plomo"
                >
                  <td
                    [ngClass]="{
                      'selected-subcategory': selectedIdCategoria === '1'
                    }"
                    style="padding: 3px !important; margin-right: 10px"
                  >
                    <a
                      (click)="
                        selectOption('1');
                        visibilidad('#subMenuFotografia');
                        buscarConsulta('1', '')
                      "
                    >
                      Fotografías
                    </a>
                  </td>
                  <td
                    [ngClass]="{
                      'selected-subcategory': selectedIdCategoria === '2'
                    }"
                    style="padding: 3px !important; margin-right: 10px"
                  >
                    <a
                      (click)="
                        selectOption('2');
                        visibilidad('#subMenuPortada');
                        buscarConsulta('2', '')
                      "
                      >Páginas Históricas</a
                    >
                  </td>
                  <!--td [ngClass]="{'selected-subcategory': selectedIdCategoria === '3'}" style="padding:3px!important;margin:0px!important;">
                    <a>Hemeroteca</a>
                  </td-->
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--contenedor fijo 3 fin-->
</div>
<!-- div fijo-->

<!--p>{{ selectedDateRange?.begin | date }} - {{ selectedDateRange?.end | date }}</p-->

<!--button mat-button (click)="clearDates()">Limpiar</button-->

<!-- Modal de selección de rango de fechas -->
<app-date-range-modal
  [isOpen]="isDateRangeModalOpen"
  [minDate]="minDate"
  [maxDate]="maxDate"
  (dateRangeSelected)="onDateRangeSelectedFromModal($event)"
  (closeEvent)="closeDateRangeModal()">
</app-date-range-modal>
